import * as ROUTES from 'constants/routes'
import { styled } from '@mui/material'
import { Redirect } from 'react-router-dom'
import { isExternalDemo } from 'config'
import { useAuth } from '../services/auth'
import ContentLoading from './shared/ContentLoading'
import useFlagCondition from './shared/useFlagCondition'

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: 'center',
}))

const Home = (): JSX.Element => {
  const { isAuthenticated, error, isLoading, loginWithRedirect, hasPermission } = useAuth()
  const experimentPlanningEnabled = useFlagCondition('experimentPlanningEnabled')

  if (error && error?.message.indexOf('parameter organization is invalid') !== -1) {
    loginWithRedirect({
      returnTo: window.location.origin,
    })
  }

  return (
    <Root>
      {isLoading && <ContentLoading />}
      {!isLoading && !isAuthenticated && <Redirect to="/login" />}
      {!isLoading && isAuthenticated && isExternalDemo && <Redirect to="/register" />}
      {!isLoading && isAuthenticated && (
        <>
          {hasPermission('cells:read') && <Redirect to={ROUTES.CELL_BROWSING} />}
          {hasPermission('cells:graph_visualization:read') && (
            <Redirect to={ROUTES.CELL_VISUALIZATIONS} />
          )}
          {hasPermission('runs:read') && experimentPlanningEnabled && (
            <Redirect to={ROUTES.EXPERIMENT_PLANNING} />
          )}
          {hasPermission('runs:read') && <Redirect to={ROUTES.RUNS} />}
        </>
      )}
    </Root>
  )
}

export default Home
